<div [formGroup]="dateTimeForm" class="form-group">
  @if (showLabel) {
    <label [innerText]="textLabel" for="date"></label>
  }
  @if (showRequiredFieldIndicator) {
    <scitis-required-field-indicator></scitis-required-field-indicator>
  }
  <div class="form-row">
    <div class="col">
      <div class="input-group">
        <input #start="ngbDatepicker"
          (change)="onFocusOut()"
          (click)="start.toggle()"
          (dateSelect)="onFocusOut()"
          (focusout)="onFocusOut()"
          [maxDate]="maxDate"
          [footerTemplate]="footerTemplate"
          [ngClass]="{ 'is-invalid': showRequiredMessage && submitted && formControls.date.errors }"
          [placeholder]="dateTimeFormat"

          class="form-control bg-white"
          formControlName="date"
          id="date"
          ngbDatepicker
          readonly>
          <ng-template #footerTemplate>
            <div class="pt-1 pb-2 px-2">
              <div class="divider my-2"></div>
              @if (showTimeComponent) {
                <h6 class="h6" translate>Set time</h6>
              }
              <div class="form-row">
                <div class="col">
                  @if (showTimeComponent) {
                    <ngb-timepicker (change)="onFocusOut()"
                      (focusout)="onFocusOut()"
                      class="time-picker"
                      [ngClass]="{ 'is-invalid': showRequiredMessage && submitted && formControls.time.errors }"
                      [seconds]="showSeconds"
                      formControlName="time"
                      id="startTime">
                    </ngb-timepicker>
                  }
                </div>
                <div class="col-auto">
                  <button (click)="onChooseNowChange(); $event.preventDefault()" (focusout)="onFocusOut()"
                    class="btn btn-outline-primary btn-block" [ngbTooltip]="'Current time' | translate"
                    placement="top">
                    <span class="fa-solid fa-clock"></span>
                  </button>
                </div>
              </div>
              @if (showRequiredMessage && submitted && formControls.time.errors) {
                <div class="invalid-feedback">
                  @if (showRequiredMessage && (formControls.time.errors.required || formControls.time.errors.initialized)) {
                    <span
                    [innerText]="timePickerErrorMessage"></span>
                  }
                </div>
              }
            </div>
          </ng-template>
          <div class="input-group-append">
            <button (click)="start.toggle()" class="btn btn-outline-secondary" type="button">
              <em class="fa-solid fa-calendar"></em>
            </button>
          </div>
          @if (showRequiredMessage && submitted && formControls.date.errors && formControls.date.errors.required) {
            <div
              class="invalid-feedback">
              @if (showRequiredMessage && formControls.date.errors.required) {
                <span
                [innerText]="datePickerErrorMessage"></span>
              }
            </div>
          }
        </div>
      </div>
    </div>

  </div>
